// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  min-height:100%;
}

body {
  height:100vh;
}

.App {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* AI-GEN START - Cursor */
.react-chatbot-kit-user-chat-message-container {
  display: flex;
  margin: 15px 0;
  justify-content: flex-end;
}

.react-chatbot-kit-user-avatar-container {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-left: 12.5px;
  background-color: #3d4e8d;
  display: flex;
  justify-content: center;
  align-items: center;
}

.react-chatbot-kit-user-avatar-icon {
  fill: #fff;
  width: 15px;
  height: 15px;
}

.react-chatbot-kit-user-chat-message {
  background-color: #f1f1f1;
  padding: 10px;
  border-radius: 5px;
  font-size: 0.9rem;
  color: #585858;
  font-weight: medium;
  position: relative;
  text-align: left;
}

.react-chatbot-kit-user-chat-message-arrow {
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #f1f1f1;
  position: absolute;
  right: -7px;
  top: 13px;
}

.react-chatbot-kit-chat-bot-message-container {
  width: 1000px;
  display: flex;
  margin: 15px 0;
  justify-content: flex-start;
}

.react-chatbot-kit-chat-bot-avatar-container {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 1.2rem;
  margin-right: 12.5px;
  background-color: #d8d8d8;
  display: flex;
  justify-content: center;
  align-items: center;
}

.react-chatbot-kit-chat-bot-avatar-icon {
  fill: #494646;
  width: 22.5px;
  height: 22.5px;
}

.react-chatbot-kit-chat-bot-avatar-letter {
  color: #1d1d1d;
  margin: 0;
  padding: 0;
}

.react-chatbot-kit-chat-bot-message {
  background-color: #2898ec;
  padding: 10px;
  border-radius: 5px;
  font-size: 0.9rem;
  color: #fff;
  font-weight: medium;
  position: relative;
  text-align: left;
}

.react-chatbot-kit-chat-bot-message-arrow {
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 8px solid #2898ec;
  position: absolute;
  left: -7px;
  top: 13px;
}

.react-chatbot-kit-chat-bot-loading-icon-container {
  height: 17px;
  width: 25px;
}

.chatbot-loader-container {
  display: flex;
  width: 100%;
  justify-content: center;
}

#chatbot-loader #chatbot-loader-dot1 {
  animation: load 1s infinite;
}

#chatbot-loader #chatbot-loader-dot2 {
  animation: load 1s infinite;
  animation-delay: 0.2s;
}

#chatbot-loader #chatbot-loader-dot3 {
  animation: load 1s infinite;
  animation-delay: 0.4s;
}

@keyframes load {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.react-chatbot-kit-chat-container {
  width: 100%;
  height: 100%;
}

.react-chatbot-kit-chat-inner-container {
  height: 90%;
  background-color: #fff;
  border-radius: 3px;
  border-radius: 5px;
}

.react-chatbot-kit-chat-header {
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  background-color: #efefef;
  font-family: Arial;
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  color: #514f4f;
  padding: 12.5px;
  font-weight: bold;
}

.react-chatbot-kit-chat-input-container {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
}

.react-chatbot-kit-chat-message-container {
  padding: 0 17.5px 10px 17.5px;
  overflow: scroll;
  overflow-x: hidden;
  height: 300px; /* AI-GEN Cursor */ 
}

.react-chatbot-kit-chat-input {
  width: 100%;
  padding: 12.5px;
  border: none;
  font-size: 0.85rem;
  border-top: 1px solid #d8d8d8;
  border-bottom-left-radius: 5px;
}

.react-chatbot-kit-chat-input-form {
  width: 100%;
  display: flex;
}

.react-chatbot-kit-chat-input::placeholder {
  color: #585858;
}

.react-chatbot-kit-chat-btn-send {
  background-color: #2898ec;
  width: 100px;
  border: none;
  color: #fff;
}

.react-chatbot-kit-chat-btn-send-icon {
  fill: #fff;
  width: 15px;
  margin: 0 auto;
}

.react-chatbot-kit-error {
  background-color: #fff;
  border-radius: 3px;
  padding: 15px;
}

.react-chatbot-kit-error-container {
  width: 260px;
}

.react-chatbot-kit-error-header {
  font-size: 1.3rem;
  color: #1d1d1d;
  margin-bottom: 30px;
}

.react-chatbot-kit-error-docs {
  display: block;
  margin: 25px auto;
  color: rgb(56, 104, 139);
  padding: 8px;
  border: 1px solid rgb(40, 152, 236);
  width: 130px;
  text-align: center;
  text-decoration: none;
  font-size: 1rem;
}
/* AI-GEN END */ 

/* AI-GEN START - Cursor */
.sip-trace-file-content {
  width: 100%;
  height: 100px;
  font-family: Arial;
  font-size: 0.9rem;
  padding: 10px 20px;
  box-sizing: border-box;
  resize: none;
}
/* AI-GEN END */
`, "",{"version":3,"sources":["webpack://./src/main.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa,EAAE,kBAAkB;AACnC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;EACZ,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;AACA,eAAe;;AAEf,0BAA0B;AAC1B;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;AACA,eAAe","sourcesContent":["html, body {\n  min-height:100%;\n}\n\nbody {\n  height:100vh;\n}\n\n.App {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* AI-GEN START - Cursor */\n.react-chatbot-kit-user-chat-message-container {\n  display: flex;\n  margin: 15px 0;\n  justify-content: flex-end;\n}\n\n.react-chatbot-kit-user-avatar-container {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  margin-left: 12.5px;\n  background-color: #3d4e8d;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.react-chatbot-kit-user-avatar-icon {\n  fill: #fff;\n  width: 15px;\n  height: 15px;\n}\n\n.react-chatbot-kit-user-chat-message {\n  background-color: #f1f1f1;\n  padding: 10px;\n  border-radius: 5px;\n  font-size: 0.9rem;\n  color: #585858;\n  font-weight: medium;\n  position: relative;\n  text-align: left;\n}\n\n.react-chatbot-kit-user-chat-message-arrow {\n  width: 0;\n  height: 0;\n  border-top: 8px solid transparent;\n  border-bottom: 8px solid transparent;\n  border-left: 8px solid #f1f1f1;\n  position: absolute;\n  right: -7px;\n  top: 13px;\n}\n\n.react-chatbot-kit-chat-bot-message-container {\n  width: 1000px;\n  display: flex;\n  margin: 15px 0;\n  justify-content: flex-start;\n}\n\n.react-chatbot-kit-chat-bot-avatar-container {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  font-size: 1.2rem;\n  margin-right: 12.5px;\n  background-color: #d8d8d8;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.react-chatbot-kit-chat-bot-avatar-icon {\n  fill: #494646;\n  width: 22.5px;\n  height: 22.5px;\n}\n\n.react-chatbot-kit-chat-bot-avatar-letter {\n  color: #1d1d1d;\n  margin: 0;\n  padding: 0;\n}\n\n.react-chatbot-kit-chat-bot-message {\n  background-color: #2898ec;\n  padding: 10px;\n  border-radius: 5px;\n  font-size: 0.9rem;\n  color: #fff;\n  font-weight: medium;\n  position: relative;\n  text-align: left;\n}\n\n.react-chatbot-kit-chat-bot-message-arrow {\n  width: 0;\n  height: 0;\n  border-top: 8px solid transparent;\n  border-bottom: 8px solid transparent;\n  border-right: 8px solid #2898ec;\n  position: absolute;\n  left: -7px;\n  top: 13px;\n}\n\n.react-chatbot-kit-chat-bot-loading-icon-container {\n  height: 17px;\n  width: 25px;\n}\n\n.chatbot-loader-container {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n}\n\n#chatbot-loader #chatbot-loader-dot1 {\n  animation: load 1s infinite;\n}\n\n#chatbot-loader #chatbot-loader-dot2 {\n  animation: load 1s infinite;\n  animation-delay: 0.2s;\n}\n\n#chatbot-loader #chatbot-loader-dot3 {\n  animation: load 1s infinite;\n  animation-delay: 0.4s;\n}\n\n@keyframes load {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n.react-chatbot-kit-chat-container {\n  width: 100%;\n  height: 100%;\n}\n\n.react-chatbot-kit-chat-inner-container {\n  height: 90%;\n  background-color: #fff;\n  border-radius: 3px;\n  border-radius: 5px;\n}\n\n.react-chatbot-kit-chat-header {\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n  background-color: #efefef;\n  font-family: Arial;\n  display: flex;\n  align-items: center;\n  font-size: 0.85rem;\n  color: #514f4f;\n  padding: 12.5px;\n  font-weight: bold;\n}\n\n.react-chatbot-kit-chat-input-container {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n}\n\n.react-chatbot-kit-chat-message-container {\n  padding: 0 17.5px 10px 17.5px;\n  overflow: scroll;\n  overflow-x: hidden;\n  height: 300px; /* AI-GEN Cursor */ \n}\n\n.react-chatbot-kit-chat-input {\n  width: 100%;\n  padding: 12.5px;\n  border: none;\n  font-size: 0.85rem;\n  border-top: 1px solid #d8d8d8;\n  border-bottom-left-radius: 5px;\n}\n\n.react-chatbot-kit-chat-input-form {\n  width: 100%;\n  display: flex;\n}\n\n.react-chatbot-kit-chat-input::placeholder {\n  color: #585858;\n}\n\n.react-chatbot-kit-chat-btn-send {\n  background-color: #2898ec;\n  width: 100px;\n  border: none;\n  color: #fff;\n}\n\n.react-chatbot-kit-chat-btn-send-icon {\n  fill: #fff;\n  width: 15px;\n  margin: 0 auto;\n}\n\n.react-chatbot-kit-error {\n  background-color: #fff;\n  border-radius: 3px;\n  padding: 15px;\n}\n\n.react-chatbot-kit-error-container {\n  width: 260px;\n}\n\n.react-chatbot-kit-error-header {\n  font-size: 1.3rem;\n  color: #1d1d1d;\n  margin-bottom: 30px;\n}\n\n.react-chatbot-kit-error-docs {\n  display: block;\n  margin: 25px auto;\n  color: rgb(56, 104, 139);\n  padding: 8px;\n  border: 1px solid rgb(40, 152, 236);\n  width: 130px;\n  text-align: center;\n  text-decoration: none;\n  font-size: 1rem;\n}\n/* AI-GEN END */ \n\n/* AI-GEN START - Cursor */\n.sip-trace-file-content {\n  width: 100%;\n  height: 100px;\n  font-family: Arial;\n  font-size: 0.9rem;\n  padding: 10px 20px;\n  box-sizing: border-box;\n  resize: none;\n}\n/* AI-GEN END */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
